import type { ReactNode } from 'react';
import { TrendingDown, TrendingUp, Minus } from 'lucide-react';

interface KpiCardProps {
  label: string;
  value: ReactNode;
  hint?: string;
  trend?: number | null; // percent change; positive = up arrow, negative = down
  trendUnit?: string;
}

export function KpiCard({ label, value, hint, trend, trendUnit = '%' }: KpiCardProps) {
  let trendEl: ReactNode = null;
  if (trend != null && Number.isFinite(trend)) {
    const t = trend;
    if (t > 0.05) {
      trendEl = (
        <span className="inline-flex items-center gap-1 text-rose-600 dark:text-rose-400">
          <TrendingUp className="h-3 w-3" />
          {t.toFixed(1)}{trendUnit}
        </span>
      );
    } else if (t < -0.05) {
      trendEl = (
        <span className="inline-flex items-center gap-1 text-emerald-600 dark:text-emerald-400">
          <TrendingDown className="h-3 w-3" />
          {Math.abs(t).toFixed(1)}{trendUnit}
        </span>
      );
    } else {
      trendEl = (
        <span className="inline-flex items-center gap-1 text-slate-500">
          <Minus className="h-3 w-3" />
          0{trendUnit}
        </span>
      );
    }
  }

  return (
    <div className="card p-4">
      <p className="text-xs font-medium uppercase tracking-wide text-slate-500">{label}</p>
      <div className="mt-2 flex items-baseline justify-between gap-2">
        <span className="text-2xl font-bold tabular-nums text-slate-900 dark:text-slate-100">
          {value}
        </span>
        {trendEl}
      </div>
      {hint && <p className="mt-1 text-xs text-slate-500">{hint}</p>}
    </div>
  );
}
